import React, { useRef, useState, useEffect } from 'react';
import { CollapseWrapper, CollapseContent } from './styled';
/**
 * Custom hook to manage collapse state and behavior.
 *
 * @template T
 * @returns {Object} The collapse state and control functions.
 * @param {boolean} [isOpenInit=false] - Initial state of the collapse.
 * @returns {function} toggleCollapse - Function to toggle the collapse state.
 * @returns {function} setOpenCollapse - Function to set the collapse state.
 * @returns {React.RefObject<T>} collapseControlRef - Ref to be assigned to the element that controls expanding or collapsing.
 */
export function useCollapse(isOpenInit) {
    const [isOpen, setOpenCollapse] = useState(() => isOpenInit !== null && isOpenInit !== void 0 ? isOpenInit : false);
    const collapseControlRef = useRef(null);
    const toggleCollapse = () => setOpenCollapse((prevState) => !prevState);
    useEffect(() => {
        if (collapseControlRef.current) {
            collapseControlRef.current.setAttribute('aria-expanded', isOpen.toString());
        }
        else {
            console.error('Please pass collapseControlRef from useCollapse hook to appropriate node');
        }
    }, [isOpen]);
    return { isOpen, toggleCollapse, setOpenCollapse, collapseControlRef };
}
export const Collapse = ({ isOpen = false, component, children, duration = 500, ...props }) => {
    const nodeRef = useRef(null);
    useEffect(() => {
        nodeRef.current.style.gridTemplateRows = isOpen ? '1fr' : '';
    }, [isOpen]);
    return (React.createElement(CollapseWrapper, { ref: nodeRef, as: component, duration: duration, ...props },
        React.createElement(CollapseContent, null, children)));
};
